import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import queryString from 'query-string'
import {
  defaultRowRenderer,
  Table,
} from '@rapiddot/react-virtual-list'
import './Table.css'

export default class GenericTable extends React.Component {
  static propTypes = {
    totalItems: PropTypes.number.isRequired,
    getItem: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props)
    this.state = { 
      selectedIndex: null,
      scrolledColumns: 0,
    }
  }

  // componentDidMount() {
  //   this.setState({
  //     sortBy: this.props.sortBy, 
  //     sortDirection: this.props.sortDirection,
  //   })
  // }

  _noRowsRenderer  = () => {
    return (
      <div>
        No rows
      </div>
    )
  }

  _onRowClick = ({ index }) => {
    this.setState({ selectedIndex: index });
    this.props.onRowClick && this.props.onRowClick(index);
  }

  _rowClassName = ({ index }) => {
    return 'table-row'
  }

  _getLoader() {
    return (
      <div>Loading articles</div>
    )
  }

  _onSort = (data) => {
    const { location } = this.props
    const query = queryString.stringify({
      ...location.query, 
      ordering: `${data.sortDirection === 'DESC' ? '-' : ''}${data.sortBy.replace(/\./g, '__')}`
    })
    browserHistory.push(`${location.pathname}?${query}`)
  }

  _onScrollRight = () => {
    let { scrolledColumns } = this.state;
    this.setState({scrolledColumns: scrolledColumns + 1});
  }

  _onScrollLeft = () => {
    let { scrolledColumns } = this.state;
    this.setState({scrolledColumns: scrolledColumns - 1});
  }


  render() {
    const { 
      getItem, 
      totalItems, 
      children,
      headerHeight,
      rowHeight, 
      className, 
      rowClassName,
      maxVisibleColumns,
      stickyStyle,
      stickyTopOffset
    } = this.props;

    const defaultStickyStyle = {"zIndex": "100", "top": "60px", "paddingTop": "20px"};
    const defaultStickyTopOffset = -56;

    return <Table
      useWindow={true}
      isLoading={false}
      className={className}
      loader={this._getLoader()}
      rowHeight={rowHeight || 45}
      headerHeight={headerHeight || 40}
      rowCount={totalItems}
      rowGetter={getItem}
      onSort={this._onSort}
      sortBy={this.props.sortBy}
      sortDirection={this.props.sortDirection}
      rowClassName={rowClassName || this._rowClassName}
      maxVisibleColumns={maxVisibleColumns}
      scrolledColumns={this.state.scrolledColumns}
      onScrollRight={this._onScrollRight}
      onScrollLeft={this._onScrollLeft}  
      onRowClick={this._onRowClick}
      stickyStyle={stickyStyle || defaultStickyStyle}
      stickyTopOffset={stickyTopOffset || defaultStickyTopOffset}
      defaultRowRenderer={defaultRowRenderer}>
      {children}
    </Table>
  }
}



// WEBPACK FOOTER //
// ./src/components/Generic/Table.js